
<div style="text-align: center; margin: 20px;">
  <p>Redirecting...</p>
</div>

